export const selectData = (state) => state.meetings.data;
export const selectError = (state) => state.meetings.error;
export const selectLoading = (state) => state.meetings.loading;
export const selectFetchCounter = (state) => state.meetings.fetchCounter;
